import React, { useState, useMemo } from 'react';
import { Tabs as UITabs, COMPOENT_THEME } from '@umu/umu-design';
import './index.scss';
export interface ITabPane {
    tab: string;
    key: string;
}
interface IProps {
    params: ITabPane[];
    activeKey?: string;
    className?: string;
    type?: string;
    isValidChange?: boolean;
    onValidChange?: (item: ITabPane) => boolean;
    onChange?: (item: ITabPane) => void | boolean | Promise<boolean>;
}

export const Tabs = (props: IProps) => {
    const { params,  activeKey, isValidChange = false,onChange,onValidChange } = props;
    const defaultSelected = useMemo(() => {
        const selectIndex = params.findIndex((item: ITabPane) => String(item.key) === String(activeKey));
        return selectIndex > -1 ? selectIndex : 0;
    }, [activeKey, params])
    const [activeIndex, setActiveIndex] = useState<number>(defaultSelected);
    const onTabChange = async (index: number)  => {
        const items = params[index];
        if (isValidChange) {
            if (onChange) {
                const isChange = await onChange(items)
                isChange && setActiveIndex(index);
            }
            return;
        }
        setActiveIndex(index);
        if (onChange) {
            onChange(items);
        }
    }
    const onTabChangeBefore = (index: number) => {
        const items = params[index];
        if(isValidChange && onValidChange) {
            return onValidChange(items);
        }
        return true
    }
    return (
        <UITabs.Tabs defaultSelected={activeIndex} theme={COMPOENT_THEME.BLUE} onTabChange={onTabChange} onTabChangeBefore={onTabChangeBefore}>
            {params.map((item: ITabPane) => {
                return (
                    <UITabs.Tab key={item.key}>{item.tab}</UITabs.Tab>
                );
            })}
        </UITabs.Tabs>
    );
};
